import { useState, useEffect } from 'react';

const CookieConsentBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Hidden dev feature: Add ?reset_consent=1 to URL to force banner to show again
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('reset_consent') === '1') {
      localStorage.removeItem('cookie_consent');
      console.log('🔧 [Dev] Cookie consent reset via URL parameter');
      // Clean the URL
      window.history.replaceState({}, '', window.location.pathname);
    }
    
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookie_consent');
    
    if (!consent) {
      // Show banner after a small delay for better UX
      setTimeout(() => {
        setShowBanner(true);
        setTimeout(() => setIsVisible(true), 50); // Fade-in effect
      }, 1000);
    } else if (consent === 'accepted') {
      // User previously accepted, load tracking scripts
      loadTrackingScripts();
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setIsVisible(false);
    setTimeout(() => {
      setShowBanner(false);
      loadTrackingScripts();
    }, 300);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setIsVisible(false);
    setTimeout(() => setShowBanner(false), 300);
  };

  const loadTrackingScripts = () => {
    // Load Meta Pixel
    if (!window.fbq) {
      const metaScript = document.createElement('script');
      metaScript.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1491218625689018');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(metaScript);

      // Add noscript fallback
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=1491218625689018&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }

    // Load PostHog
    if (!window.posthog) {
      const posthogScript = document.createElement('script');
      posthogScript.innerHTML = `
        !(function (t, e) {
            var o, n, p, r;
            e.__SV ||
                ((window.posthog = e),
                (e._i = []),
                (e.init = function (i, s, a) {
                    function g(t, e) {
                        var o = e.split(".");
                        2 == o.length && ((t = t[o[0]]), (e = o[1])),
                            (t[e] = function () {
                                t.push(
                                    [e].concat(
                                        Array.prototype.slice.call(
                                            arguments,
                                            0,
                                        ),
                                    ),
                                );
                            });
                    }
                    ((p = t.createElement("script")).type =
                        "text/javascript"),
                        (p.crossOrigin = "anonymous"),
                        (p.async = !0),
                        (p.src =
                            s.api_host.replace(
                                ".i.posthog.com",
                                "-assets.i.posthog.com",
                            ) + "/static/array.js"),
                        (r =
                            t.getElementsByTagName(
                                "script",
                            )[0]).parentNode.insertBefore(p, r);
                    var u = e;
                    for (
                        void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
                            u.people = u.people || [],
                            u.toString = function (t) {
                                var e = "posthog";
                                return (
                                    "posthog" !== a && (e += "." + a),
                                    t || (e += " (stub)"),
                                    e
                                );
                            },
                            u.people.toString = function () {
                                return u.toString(1) + ".people (stub)";
                            },
                            o =
                                "init me ws ys ps bs capture je Di ks register register_once register_for_session unregister unregister_for_session Ps getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Es $s createPersonProfile Is opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing Ss debug xs getPageViewId captureTraceFeedback captureTraceMetric".split(
                                    " ",
                                ),
                            n = 0;
                        n < o.length;
                        n++
                    )
                        g(u, o[n]);
                    e._i.push([i, s, a]);
                }),
                (e.__SV = 1));
        })(document, window.posthog || []);
        posthog.init("phc_yJW1VjHGGwmCbbrtczfqqNxgBDbhlhOWcdzcIJEOTFE", {
            api_host: "https://us.i.posthog.com",
            person_profiles: "identified_only",
        });
      `;
      document.body.appendChild(posthogScript);
    }
  };

  if (!showBanner) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[9999] transition-all duration-300 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
    >
      <div className="bg-white border-t-2 border-gray-200 shadow-2xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex-1">
              <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-2">
                🍪 We value your privacy
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                We use cookies and similar technologies to improve your experience, analyze site usage, 
                and assist in our marketing efforts. This includes Meta Pixel and PostHog analytics. 
                By clicking "Accept", you consent to the use of these technologies. You can decline, 
                and the site will function normally without tracking.{' '}
                <a 
                  href="/privacy" 
                  className="text-blue-600 hover:text-blue-700 underline font-medium"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Learn more
                </a>
              </p>
            </div>
            <div className="flex gap-3 w-full sm:w-auto">
              <button
                onClick={handleDecline}
                className="flex-1 sm:flex-none px-6 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors duration-200 border border-gray-300"
              >
                Decline
              </button>
              <button
                onClick={handleAccept}
                className="flex-1 sm:flex-none px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg"
              >
                Accept All
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
